export default __webpack_public_path__ + "img/wellbore-diagrams.2c00d0d0.png";